
        <ng-container kendoSliderLocalizedMessages
            i18n-increment="kendo.slider.increment|The title of the **Increase** button of the Slider."
            increment="increment"
            i18n-decrement="kendo.slider.decrement|The title of the **Decrease** button of the Slider."
            decrement="decrement"
            i18n-dragHandle="kendo.slider.dragHandle|The title of the drag handle of the Slider."
            dragHandle="Drag"
        >
        <div class="k-slider-wrap" #wrap
            [class.k-slider-buttons]="showButtons"
            [class.k-slider-topleft]="tickPlacement === 'before'"
            [class.k-slider-bottomright]="tickPlacement === 'after'"
            [kendoEventsOutsideAngular]="{ click: onWrapClick, keydown: onKeyDown }"
            >
            <button *ngIf="showButtons" type="button" #decreaseButton
                class="k-button-decrease k-button k-button-md k-rounded-full k-button-rectangle k-button-solid k-button-solid-base k-icon-button"
                [title]="decrementMessage"
                [attr.tabindex]="-1"
                role="presentation">
                    <span class="k-button-icon k-icon"
                        [class.k-i-arrow-w]="!vertical"
                        [class.k-i-arrow-s]="vertical">
                    </span>
            </button>
            <div class="k-slider-track-wrap">
                <ul kendoSliderTicks
                    #ticks
                    *ngIf="tickPlacement !== 'none'"
                    [tickTitle]="title"
                    [vertical]="vertical"
                    [step]="smallStep"
                    [largeStep]="largeStep"
                    [min]="min"
                    [max]="max"
                    [labelTemplate]="labelTemplate?.templateRef"
                    [attr.aria-hidden]="true"
                >
                </ul>
                <div #track class="k-slider-track">
                    <div #sliderSelection class="k-slider-selection">
                    </div>
                    <a #draghandle
                        role="slider"
                        [attr.aria-valuemin]="min"
                        [attr.aria-valuemax]="max"
                        [attr.aria-valuenow]="currentValue"
                        [attr.aria-valuetext]="currentValue"
                        [attr.aria-disabled]="disabled ? true : undefined"
                        [attr.aria-readonly]="readonly ? true : undefined"
                        [attr.aria-orientation]="vertical ? 'vertical' : 'horizontal'"
                        [style.touch-action]="isDisabled ? '' : 'none'"
                        class="k-draghandle"
                        [title]="dragHandleMessage"
                        [attr.tabindex]="disabled ? '-1' : tabIndex"
                        [id]="focusableId"
                        kendoDraggable
                        (kendoPress)="ifEnabled(handleDragPress, $event)"
                        (kendoDrag)="ifEnabled(onHandleDrag, $event)"
                        (kendoRelease)="ifEnabled(onHandleRelease, $event)"
                    ></a>
                </div>
            </div>
            <button *ngIf="showButtons" type="button" #increaseButton
                class="k-button-increase k-button k-button-md k-rounded-full k-button-rectangle k-button-solid k-button-solid-base k-icon-button"
                [title]="incrementMessage"
                (click)="$event.preventDefault()"
                [attr.tabindex]="-1"
                [attr.aria-label]="currentValue"
                role="presentation">
                    <span class="k-button-icon k-icon"
                        [class.k-i-arrow-e]="!vertical"
                        [class.k-i-arrow-n]="vertical">
                    </span>
            </button>
            <kendo-resize-sensor (resize)="sizeComponent(false)"></kendo-resize-sensor>
        </div>
  